import {DrawText} from '@platform/ui/DrawReference';
import type {Snapshot} from '@platform/contracts/x';
import {drawNumber} from '@platform/contracts/drawNumber';
import {useCopy,useUi} from '@platform/ui/config';
import {BottomCta} from './BottomCta';
import './DrawStartingCta.css';

// Phase emphasis is owned by RoomFooter; this message has no separate timer.
export function DrawStartingCta({state}:{state:Snapshot}){
 const t=useCopy(),ui=useUi();
 const label=t('room.drawStartingPrompt').toLocaleUpperCase(ui.controls.prizeDisplayLocale);
 return <BottomCta className="room-next-action" revealKey={state.drawId+':starting'} data-ui="draw-starting-cta">
  <p className="draw-starting-message" role="status" aria-live="off">
   <small className="draw-starting-number" data-ui="draw-starting-number" style={{color:ui.tokens['--room-accent']}}><DrawText copyKey="room.selectionDraw" draw={drawNumber(state)}/></small>
   <span>{label}</span>
  </p>
 </BottomCta>;
}
